import Button from '@/components/common/Button';

export default {
	routes: {
		home: {
			path: '/',
			slug: 'home',
			name: 'home',
		},
		newProducts: {
			path: '/shop/?sort=latest',
			slug: 'new-in',
			name: 'newProducts',
			store: true,
			header: true,
			desktop: 3,
			mobile: 1,
			hasColor: true,
		},
		bestSellers: {
			path: '/shop/?sort=popularity',
			slug: 'best-sellers',
			name: 'bestSellers',
			store: true,
			header: true,
			desktop: 4,
			mobile: 2,
			hasColor: true,
		},
		blog: {
			path: '/blog',
			slug: 'blog',
			name: 'blog',
			header: true,
			desktop: 5,
			mobile: 5,
		},
		aboutUs: {
			path: '/about-us',
			slug: 'about-us',
			name: 'aboutUs',
			forCustomer: true,
		},
		shippingDetails: {
			path: '/shipping-details',
			slug: 'Shipping-details',
			name: 'shippingDetails',
			forCustomer: true,
		},
		privacyAndReturns: {
			path: '/privacy-and-returns',
			slug: 'privacy-and-returns',
			name: 'privacyAndReturns',
			forCustomer: true,
		},

		account: {
			path: '/account/',
			slug: 'account',
			name: 'account',
			private: true,
		},

		orderHistory: {
			path: '/account/order-history/',
			slug: 'order-history',
			name: 'orderHistory',
			private: true,
		},

		accountAddresses: {
			path: '/account/addresses/',
			slug: 'addresses',
			name: 'addresses',
			private: true,
		},

		accountBalance: {
			path: '/account/balance/',
			slug: 'balance',
			name: 'balance',
			private: true,
		},

		shop: {
			path: '/shop',
			slug: 'shop',
			name: 'shop',
		},
		wishlist: {
			path: '/wishlist',
			slug: 'wishlist',
			name: 'wishlist',
		},
		cart: {
			path: '/cart',
			slug: 'cart',
			name: 'cart',
		},
		checkout: {
			path: '/checkout',
			slug: 'checkout',
			name: 'checkout',
		},
		//! Auth
		login: {
			path: '/login',
			slug: 'login',
			name: 'login',
		},
		register: {
			path: '/register',
			slug: 'register',
			name: 'register',
		},
		forgotPassword: {
			path: '/forgot-password',
			slug: 'forgot-password',
			name: 'forgot-password',
		},
		resetPassword: {
			path: '/reset-password',
			slug: 'reset-password',
			name: 'reset-password',
		},
		unsubscribe: {
			path: '/unsubscribe/',
			slug: 'unsubscribe',
			name: 'unsubscribe',
		},
	},
	package: {
		accountConfig: {
			button: {
				'full-width': {
					component: Button,
					props: { className: 'width-100 medium' },
				},
				'green-small-text': {
					component: Button,
					props: { className: 'width-100 fonts-greenST', btnType: 'float-underline' },
				},
				'promo-code-version': {
					component: Button,
					props: { className: 'medium' },
				},
				'balance-version': {
					component: Button,
					props: { className: 'medium' },
				},
				// 'green-large-text': {
				// 	component: Button,
				// 	props: { className: 'height-100', btnType: 'float-underline' },
				// },
			},
		},
		checkoutAddressFormFields: [
			{
				fieldType: 'input',
				labelProps: { name: 'first_name', errorKey: 'first name' },
				fieldProps: {
					placeholder: 'firstNamePlaceholder',
					uppercase: true,
				},
			},
			{
				fieldType: 'input',
				labelProps: { name: 'last_name', errorKey: 'last name' },
				fieldProps: {
					placeholder: 'lastNamePlaceholder',
					uppercase: true,
				},
			},
			// The custom address field component (CheckoutAddressField) is wired in layout.js
			// via fieldType: 'custom' and component: CheckoutAddressField
		],
		checkoutGlobalSettings: {
			hasVariants: false,
			supportsGuestCart: true,
			hasGiftSystem: true,
			hasUtensilsSystem: false,
			hasSubscriptionSystem: true,
			hasSubscriptionSms: false,
			hasVoucherSystem: false,
			hasOutOfStock: true,
			hasAddresses: true,
			hasAddressType: true,
			allowGuestCheckout: true,
			hasCommentSystem: false,
			hasFreeShippingSystem: false,
		},
		checkoutOrderConfig: {
			hasReorder: false,
			hasReview: false,
			hasSubtotal: false,
		},
		checkoutAuthConfig: {
			social: {
				google: false,
			},
		},
		accountDisplayFields: [
			{ label: 'account.account_info.firstName', value: 'first_name' },
			{ label: 'account.account_info.lastName', value: 'last_name' },
			{ label: 'account.account_info.email', value: 'email' },
		],
		accountFormFields: [
			{
				fieldType: 'input',
				labelProps: {
					label: 'account.account_info.firstName',
					name: 'first_name',
				},
				fieldProps: {
					placeholder: 'account.account_info.firstNamePlaceholder',
					uppercase: true,
				},
			},
			{
				fieldType: 'input',
				labelProps: {
					label: 'account.account_info.lastName',
					name: 'last_name',
				},
				fieldProps: {
					placeholder: 'account.account_info.lastNamePlaceholder',
					uppercase: true,
				},
			},
			{
				fieldType: 'input',
				labelProps: {
					label: 'account.account_info.email',
					name: 'email',
				},
				fieldProps: {
					disabled: true,
				},
			},
		],
		signUpFormFields: [
			{
				fieldType: 'input',
				labelProps: {
					label: 'account.account_info.firstName',
					name: 'first_name',
				},
				fieldProps: {
					placeholder: 'account.account_info.firstNamePlaceholder',
					uppercase: true,
				},
			},
			{
				fieldType: 'input',
				labelProps: {
					label: 'account.account_info.lastName',
					name: 'last_name',
				},
				fieldProps: {
					placeholder: 'account.account_info.lastNamePlaceholder',
					uppercase: true,
				},
			},
			{
				fieldType: 'input',
				labelProps: {
					label: 'account.account_info.email',
					name: 'email',
					rules: [{ type: 'email' }],
				},
				fieldProps: {
					placeholder: 'account.account_info.emailPlaceholder',
				},
			},
			{
				fieldType: 'password',
				labelProps: {
					label: 'account.password_management.password',
					name: 'password',
					rules: [{ type: 'new-password' }],
				},
				fieldProps: {
					placeholder: 'account.password_management.passwordPlaceholder',
				},
			},
		],
	},
};
